module.exports = __webpack_public_path__ + "static/media/mp.0b32daee.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/mp.svg
// module id = 2159
// module chunks = 0